import api from "./axios";

export const AdminAuditAPI = {
  list: (params) => {
    // Supprimer les valeurs vides/null/undefined — FastAPI rejette "" pour les int
    const clean = Object.fromEntries(
      Object.entries(params).filter(([, v]) => v !== "" && v !== null && v !== undefined)
    );
    return api.get("/admin/audit", { params: clean });
  },
};
